import { render, staticRenderFns } from "./ContactMassEdit.vue?vue&type=template&id=23103f28&"
import script from "./ContactMassEdit.vue?vue&type=script&lang=js&"
export * from "./ContactMassEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports